module.exports = __webpack_public_path__ + "static/portrait-man-face-scann1-8c6710a8b9ce34deb87340d36f2c3f55.png";